import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
  focusArea: {
    marginBottom: theme.spacing(2),
    color: "#4aa4ff",
    fontWeight: "400",
  },
  question: {
    color: "#353535",
    fontWeight: "500",
    marginBottom: theme.spacing(1.5),
  },
  formControl: {
    minWidth: 120,
    minHeight: 270,
    width: "100%",
  },
}));

export const AssessmentQuestion = ({
  question,
  selectedAnswerId,
  onChange,
}) => {
  const classes = useStyles();
  const [answerId, setAnswerId] = useState(selectedAnswerId);

  useEffect(() => {
    setAnswerId(selectedAnswerId);
  }, [selectedAnswerId]);

  const handleChange = (e) => {
    const { value } = e.target;
    setAnswerId(value);
    onChange(Number(value));
  };

  return (
    <>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Typography className={classes.focusArea} variant="h6" align="left">
          {question.focusAreaName}
        </Typography>
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <FormControl className={classes.formControl} component="fieldset">
          <Typography className={classes.question} variant="body2" align="left">
            {question.questionText}
          </Typography>
          <RadioGroup
            aria-label="assessmentQuestion"
            name="assessmentQuestion"
            value={`${answerId}`}
            onChange={handleChange}
          >
            {question.answers.map((answer) => (
              <FormControlLabel
                key={answer.answerId}
                value={`${answer.answerId}`}
                control={<Radio size="small" color="primary" />}
                label={
                  <Typography variant="body2" align="left">
                    {answer.answerText}
                  </Typography>
                }
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Grid>
    </>
  );
};

AssessmentQuestion.propTypes = {
  question: PropTypes.shape({
    focusAreaName: PropTypes.string.isRequired,
    questionText: PropTypes.string.isRequired,
    answers: PropTypes.arrayOf(
      PropTypes.shape({
        answerId: PropTypes.number.isRequired,
        answerText: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
  selectedAnswerId: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

AssessmentQuestion.defaultProps = {
  selectedAnswerId: 0,
};
